import React from 'react';
import Config from '../../../../../Config';
import Property from '@episerver/spa-core/Components/Property';
import Lottie from 'react-lottie';
import TruckAnimationJson from '../../../../../animations/truck-animation-loader.json';


const TruckAnimation = (props) => {
    return (
        <>
            <div className='truck-animation-container'>
                <div className='truck-animation-title'>ברגעים אלו אנו עובדים על ההזמנה שלך!</div>
                <Lottie options={{ animationData: TruckAnimationJson, loop: true, autoplay: true }} width={250} height={250} />
            </div>
        </>
    );
};
export default TruckAnimation;
